import { render, staticRenderFns } from "./HelpCenterWA.vue?vue&type=template&id=37f0774c&scoped=true"
import script from "./HelpCenterWA.vue?vue&type=script&lang=js"
export * from "./HelpCenterWA.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterWA.vue?vue&type=style&index=0&id=37f0774c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0774c",
  null
  
)

export default component.exports